
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service/[service_id]",
      function () {
        return require("private-next-pages/service/[service_id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service/[service_id]"])
      });
    }
  